<template>
  <section id="why-us" class="d-flex justify-content-center align-items-center position-relative">
    <div class="why-decor d-none d-lg-block">
      <div class="screenshot-circle1">
        <img
          class="circle-1"
          :src='"../assets/images/circle-1.png"'
          alt="feature-circle-two"
        />
      </div>
      <div class="screenshot-circle2">
        <img
          class="circle-1"
          :src='"../assets/images/circle-1.png"'
          alt="feature-circle"
        />
      </div>
      <div class="screenshot-circle3 d-none d-lg-block">
        <img
          class="circle-3"
          :src='"../assets/images/circle-3.png"'
          alt="feature-circle-three"
        />
      </div>
    </div>
    <div class="container">
      <div class="box p-4 p-lg-5">
      <img class="position-absolute" src="../assets/images/why-logo.svg" alt="logo">
      <br>
      <h1 class="f-300 mb-lg-5 mb-2 mt-sm-0 mt-lg-5 text-uppercase text-center">{{ $t('why.title') }}<span class="green ml-lg-3 ml-1 f-600">WESERVE GO</span></h1>
      <div class="row my-lg-4">
        <div v-for="(why, i) in whys" :key="i" :class="whys.length !== i + 1 ? 'mb-lg-3' : null" class="col-lg-6 p-sm-0 px-lg-5">
          <p class="d-flex align-items-center f-400">
            <span class="material-symbols-outlined green mr-3">
            done
            </span>{{ $t(why) }}
          </p>
        </div>
      </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'why',
  data() {
    return {
      whys: ['why.content1', 'why.content2', 'why.content3', 'why.content4', 'why.content5']
    }
  }
}
</script>

<style lang="sass" scoped>
  section
    padding-top: 200px
    padding-bottom: 200px

    @media (max-width: 768px) 
      padding-top: 100px
      padding-bottom: 100px

  .box
    background: #FFFFFF 0% 0% no-repeat padding-box
    box-shadow: 7px 7px 12px #00000052
    width: 100%
    position: relative

  .material-symbols-outlined
    font-size: 45px

  .position-absolute
    position: absolute
    top: -90px
    left: 0
    right: 0
    width: 185px
    height: 185px
    margin: 0 auto

    @media (max-width: 768px) 
      width: 100px
</style>
  


// WEBPACK FOOTER //
// src/components/why.vue